import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
export const AddDetailBtn = ({ icon, ...others }) => {
  return (
    <Button
      color="cyan"
      variant="solid"
      {...others}
      icon={!icon ? <PlusOutlined /> : icon}
    >
      Agregar
    </Button>
  );
};
